<div class="row">
  <div class="col-5 mb-3">
    <h2 class="title-list">{{ title }}</h2>
  </div>
  <div class="col btn-back text-end">
    <button class="btn btn-secondary" (click)="goBack()">Back</button>
  </div>
</div>
<div
  class="fw-bold bg-white p-3 rounded-5 mb-5"
  *ngIf="permissionsService.createPermission"
>
  <!-- Primera fila -->
  <div class="row mt-3">
    <div class="col">
      <label for="information" class="labelInformation">{{
        information
      }}</label>
    </div>
  </div>

  <!-- Segunda fila -->
  <div class="row mt-3">
    <div class="col">
      <label for="customerName">User Name<span class="required">*</span></label>
      <input
        type="text"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="userName"
      />
    </div>
    <div class="col">
      <label for="address" class="">Address</label>
      <input type="text" style="display:none" />  <!-- Чтобы не отображался диалог сохранения адреса -->
      <input type="text" class="form-control input-label" (input)="checkFields()" [(ngModel)]="address" />
    </div>
    <div class="col">
      <label for="customerCity">City</label>
      <input
        type="text"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="city"
      />
    </div>
  </div>

  <!-- Cuarta fila -->
  <div class="row mt-3">
    <div class="col">
      <label for="state" class="input-label">State</label>
      <div class="dropdown">
        <select
          class="form-select input-label"
          [(ngModel)]="stateSelected"
          (change)="checkFields()"
        >
          <option value="">Select Value</option>
          <option *ngFor="let option of states" [value]="option.aValue">
            {{ option.aDescription }}
          </option>
        </select>
      </div>
    </div>
    <div class="col">
      <label for="zipCode" class="">ZIP code</label>
      <input
        type="number"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="zipCode"
        name="zipCode"
      />
    </div>
    <div class="col">
      <label for="contactNumber" class=""
        >Contact number<span class="required">*</span></label
      >
      <input
        type="text"
        class="form-control input-label"
        (input)="checkFields()"
        [(ngModel)]="contactNumber"
        appFormatPhoneUs
      />
    </div>
  </div>

  <form [formGroup]="form">
    <div class="row mt-3">
      <div class="col-4">
        <label for="email">Email<span class="required">*</span></label>
        <input
          type="email"
          class="form-control input-label"
          formControlName="email"
          (input)="checkFields()"
          appFormatEmail
        />
        <div *ngIf="form.get('email')?.errors?.['emailInvalid']">
          Email is not valid
        </div>
      </div>
      <div class="col-4">
        <label for="role" class="input-label">Role<span class="required">*</span></label>
        <div class="dropdown">
          <select
            class="form-select input-label"
            [(ngModel)]="roleSelected"
            [ngModelOptions]="{standalone: true}"
            (change)="checkFields()"
            name="roleSelect">
            <option value=0>Select Value</option>
            <option *ngFor="let option of roles" [value]="option.aRoleId">
              {{ option.aRoleName }}
            </option>
          </select>
        </div>
      </div>
      
    </div>
  </form>
  
    <!-- cuarta fila -->
    <div class="row mt-3">
      <div class="col">
        <input
          type="checkbox"
          class="checkbox"
          id="active"
          name="active"
          [(ngModel)]="isActive"
        />
        <label for="active" class="m-2">Active</label>
      </div>
    </div>

  <!-- Cuarta fila -->
  <div class="row mt-3">
    <div class="col"></div>
    <!-- Columna vacía que empuja el botón hacia la derecha -->
    <div class="col-2 text-end">
      <button
        class="btn btn-primary w-100"
        [disabled]="!fieldsCompleted"
        (click)="createUser()"
      >
        Create User
      </button>
    </div>
  </div>
</div>
